"use-strict";

// Output description
// {4: fix number}{xx(2): level with leading zero}{xxxxxxxxxxxx(12): id with leading zero}
export const vehicleTreeGrid_generateUniqueId = (id, level) =>
  +`4${String(level).padStart(2, "0")}${String(id).padStart(12, "0")}`;
